define('main',['require','exports','module','appkit/app','!domReady','fukit','./auto.require'],function(require, exports, module) {
  var App = require('appkit/app');

  require('!domReady');
  
  new App({
    // set the app config
    config: require('fukit').config,
    loadModules: require('./auto.require'),
  }).start();
});

